<template>
  <div
    class="popup"
    @click="handlerClosePoster"
    @touchmove.prevent
    v-show="show"
  >
    <!-- 海报 -->
    <img :src="posterUrl" alt="" class="convert-img" @touchstart.stop v-if="posterUrl" />
    <!-- 提示语 -->
    <div class="tip-text" v-if="posterUrl">
      <div class="arrow-top"></div>
      <img
        src="@/assets/clock/clockin_icon_longpress.png"
        alt=""
        class="tip-img"
      />
      长按保存图片，分享给微信好友或微信群
    </div>
  </div>
</template>

<script>
import { getClockInPoster } from '@/api/clockin';
import { watch, ref } from '@vue/composition-api';
import { Toast } from 'vant';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit }) {
    const posterUrl = ref(null);

    watch([() => props.id, () => props.show], ([newId, newShow], [oldId]) => {
      // 当id改变时，移除之前的图片链接
      if (newId !== oldId) {
        posterUrl.value = null;
      }

      // 不显示的时候或已有图片链接，则不请求图片
      if (!newShow || posterUrl.value) {
        return;
      }

      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载图片中...',
        forbidClick: true,
      });
      getClockInPoster(newId).then((data) => {
        posterUrl.value = data.url;
        Toast.clear();
      });
    }, { immediate: true });

    const handlerClosePoster = () => {
      emit('update:show', false);
    };

    return {
      posterUrl,
      handlerClosePoster
    };
  }
};
</script>

<style lang="stylus" scoped>
.popup {
  position: fixed;
  top 0
  z-index 999
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 750px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.tip-text {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 15px;
  width: 70%;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
  font-size: 3.2vw;
  color: rgba(255, 255, 255, 0.6);

  .tip-img {
    width: 16px;
    height: 17px;
  }

  .arrow-top {
    position: absolute;
    top: -15px;
    left: 7vw;
    width: 0;
    height: 0;
    border: 8px solid rgba(0, 0, 0, 0.6);
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
  }
}

.convert-img {
  display: block;
  width: 70%;
}
</style>
